export default "__VITE_ASSET__CruXoBB8__"